import { createFileRoute } from '@tanstack/react-router'

import { FeedPage } from '@/features/social-feed'

type FeedSearch = {
  post?: number
  comments: boolean
}

export const Route = createFileRoute('/_event/feed/')({
  // TanStack Router faz parse JSON-first do querystring antes de chegar aqui
  // (`?post=24` já chega como number, `?comments=1` como number) — Number()
  // sem checagem de typeof cobre número, string numérica e ausência (NaN).
  // `validateSearch` precisa ser idempotente: o router grava o retorno de
  // volta na URL e reparseia — se `comments: search.comments === 1` só
  // aceitasse `1`/`'1'`, o primeiro parse (`1` → `true`) sobreviveria, mas o
  // segundo (reparse de `true`, já booleano) cairia pro `false` e a URL
  // oscilaria a cada navegação. Aceitar `true` também fecha o ciclo.
  validateSearch: (search: Record<string, unknown>): FeedSearch => ({
    post: Number(search.post) || undefined,
    comments: search.comments === 1 || search.comments === '1' || search.comments === true
  }),
  component: FeedPageRoute
})

function FeedPageRoute() {
  const { post, comments } = Route.useSearch()

  return <FeedPage focusPostId={post} openComments={comments} />
}
